// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S9pC3","list":"styles_list__6sGBJ","selectedItem":"styles_selectedItem__M5wTC","arrow":"styles_arrow__yMhSi"};